export const STEPS = ["people", "event_type", "duration", "drink_categories", "results"];

export const QUESTION_STEPS = ["people", "event_type", "duration", "drink_categories"];

// Correction C9 (briefing v5): Espuma/Xarope are complements of the
// destilado BASE categories — Gin, Vodka and Cachaça — never Drinks
// Prontos/Drink em Barril, and NOT Licor. Matches backend's
// Rules::ESPUMA_XAROPE_BASE_CATEGORIES. (Handoff v6/C15: "Kit Gin + Vodka"
// was removed from the catalog — Gin and Vodka standalone cover the same
// base categories and no longer need special-casing.)
export const DEPENDENT_CATEGORIES = ["espuma", "xarope"];
export const PREREQUISITE_CATEGORIES = ["gin", "vodka", "cachaca"];

// Correction C12: destilado categories still cadastro'd as "Caixa" in the
// catalog (backend blocker, handoff v5) — sending their suggested `quantity`
// to the cart today would be multiplied by the batch's Qtd/caixa at
// checkout. Kept out of "Adicionar tudo ao carrinho" until the backend
// confirms the catalog fix; the recommendation itself still renders normally.
export const CART_BLOCKED_CATEGORIES = ["gin", "vodka", "cachaca", "licor"];

// Base unit word for `sale_mode: "case"` categories that aren't measured in
// liters (cerveja is — it uses `case_liters` per item instead). Purely a
// presentation detail: the API has no per-category "nome da unidade" field.
export const CASE_BASE_UNIT_LABEL = {
  drinks_prontos: { singular: "lata", plural: "latas" },
  vinho: { singular: "garrafa", plural: "garrafas" },
  espumante: { singular: "garrafa", plural: "garrafas" },
};

// Mirrors the backend's Rules::DRINK_CATEGORIES `commercial_conversion` /
// `unit_type`, so the frontend knows which base unit `needed_quantity` and
// `fulfilled_quantity` are expressed in for each category — "ml" (barril,
// divide by 1000 to show liters), "liters" (cerveja, already liters), or
// "units" (everything sold as whole garrafas/latas/frascos/caixas-of-units).
// Kept explicit instead of inferred from a sample product so it still works
// when `available_products` is empty (e.g. an unmapped/out-of-stock block).
export const RESULT_UNIT_KIND = {
  chope: "ml",
  drink_barril: "ml",
  cerveja_tradicional: "liters",
  cerveja_artesanal: "liters",
  drinks_prontos: "units",
  vinho: "units",
  espumante: "units",
  gin: "units",
  vodka: "units",
  cachaca: "units",
  licor: "units",
  espuma: "units",
  xarope: "units",
};
